import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import CloseIcon from '@mui/icons-material/Close';
import React, {
  ChangeEvent,
  useEffect,
  useRef,
  useState,
  SetStateAction,
  Dispatch,
} from 'react';
import { QueryCache, useMutation, useQuery, useQueryClient } from 'react-query';
import { useRecoilValue } from 'recoil';
import { MultilineTextField } from '../styles/Styles';
import { SwDatesPicker } from './dateSetting/SwDatesPicker';
import { SwSnackbar } from './views/SwSnackbar';
import { SwAlert } from './views/SwAlert';
import { RESULT_OK } from '../../common/resultCode';
import {
  MobileRegexp,
  commaFormat,
  educationOffices,
  getReadGoal,
  getSchoolClassCount,
  getSchoolGradeCount,
  getSchoolInSchoolGroup,
  getWalkGoal,
  schoolGroups,
} from '../../common/helper';
import { SwConfirmDialog } from './views/SwConfirmDialog';
import { schoolListState } from '../../common/atom';
import { useSession } from '../../hooks/session';
import { KEY_SCHOOL_LIST } from '../../common/key';

interface Props {
  educationOfficeSeq: number;
  selectSchool: any;
  setSelectSchool: Dispatch<SetStateAction<any>>;
}

const INIT_READ_GOAL = '3';
const INIT_WALK_GOAL = '7000';

export const SwSchoolSelector: React.FC<Props> = ({
  educationOfficeSeq,
  selectSchool,
  setSelectSchool,
}) => {
  const { loginVal } = useSession();
  const [schoolList, setSchoolList] = useState<any[]>([]);
  const [schools, setSchools] = useState<any[]>([]);
  const [schoolSeq, setSchoolSeq] = useState<number>(0);
  const [schoolClassSeq, setSchoolClassSeq] = useState<number>(0);
  const [schoolGroupSeq, setSchoolGroupSeq] = useState<number>(0);
  const [schoolGrade, setSchoolGrade] = useState<number>(1);
  const [schoolClass, setSchoolClass] = useState<string>('1');
  const [customSchoolClass, setCustomSchoolClass] = useState<string>('');
  const [readGoal, setReadGoal] = useState<string>(INIT_READ_GOAL);
  const [walkGoal, setWalkGoal] = useState<string>(INIT_WALK_GOAL);
  const [schoolName, setSchoolName] = useState<string>('');

  const reloadSchools = (
    newSchoolList: any[],
    newSchoolGroupSeq: number,
    newEducationOfficeSeq: number
  ) => {
    const newSchools = getSchoolInSchoolGroup(
      newSchoolList,
      newSchoolGroupSeq,
      newEducationOfficeSeq
    );
    setSchools(newSchools);
  };

  useEffect(() => {
    reloadSchools(schoolList, schoolGroupSeq, educationOfficeSeq);
  }, [schoolGroupSeq, educationOfficeSeq]);

  useEffect(() => {
    const savedSchoolList = localStorage.getItem(KEY_SCHOOL_LIST);
    if (savedSchoolList) {
      const newSchoolList = JSON.parse(savedSchoolList);
      setSchoolList(newSchoolList);
    }
  }, []);

  return (
    <>
      <Box>
        <Typography className='title'>학교</Typography>
        <Box className='flex_start'>
          <TextField
            sx={{ width: '15rem' }}
            select
            value={schoolGroupSeq}
            onChange={evt => {
              setSchoolGroupSeq(Number(evt.target.value));
              setSchoolSeq(0);
              setSelectSchool({
                schoolGroupSeq: Number(evt.target.value),
                schoolSeq: 0,
              });
            }}
          >
            <MenuItem key={`school_group_${0}`} value={0}>
              초/중/고 전체
            </MenuItem>
            {schoolGroups.map((item: any, idx: number) => (
              <MenuItem key={`school_group_${idx}`} value={item.seq}>
                {item.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            sx={{ width: '15rem', ml: '.5rem' }}
            select
            value={schoolSeq}
            onChange={evt => {
              setSelectSchool({
                schoolGroupSeq: schoolGroupSeq,
                schoolSeq: Number(evt.target.value),
              });
              setSchoolSeq(Number(evt.target.value));
            }}
          >
            <MenuItem key={`school_${0}`} value={0}>
              학교 전체
            </MenuItem>
            {schools &&
              schools.map((item: any, idx: number) => (
                <MenuItem key={`school_${idx}`} value={item.schoolSeq}>
                  {item.schoolName}
                </MenuItem>
              ))}
          </TextField>
        </Box>
      </Box>
    </>
  );
};
